module.exports = __webpack_public_path__ + "media/images/orange-new-banner-e6a61e0d5fccdebf3fd794224832d6b2.svg";